// Сетка слотов доставки и порог приёма заказов.
// Источник — GET /api/settings: сетка задаётся per-инстанс через env TIME_SLOTS
// (обязателен, бэк без него не стартует), порог — в админ-настройках.
// Никаких зашитых сеток-заглушек: пока конфиг не загружен, слоты не показываются;
// неудачная загрузка не кэшируется — следующий вызов повторит запрос.
import { useEffect, useState } from 'react';
import { fetchAppSettings, FOREVER } from './settings';

const initial = {
  timeSlots: [],
  leadTimeMinutes: 120,
  shopTimezone: null,   // пояс магазина — только с сервера (env SHOP_TZ), без подстановок
  loaded: false,
};

/** Минуты от полуночи до начала слота ("13:00-15:00" → 780) */
export function slotStartMinutes(slot) {
  return parseInt(slot.slice(0, 2), 10) * 60 + parseInt(slot.slice(3, 5), 10);
}

/** Минута, до которой принимаются заказы на слот (зеркало backend
    slot_cutoff_minutes): start − порог. Порог ≥0 — приём закрывается за
    столько минут до начала слота; порог <0 — приём открыт ещё |порог|
    минут после начала идущего слота. */
export function slotCutoffMinutes(slot, leadMinutes) {
  return slotStartMinutes(slot) - leadMinutes;
}

let cache = null;   // производное значение; ставится только при успехе

function fetchDeliverySlots() {
  if (cache) return Promise.resolve(cache);
  // Сетка слотов задаётся env-переменной инстанса и в течение сессии не меняется.
  return fetchAppSettings({ maxAgeMs: FOREVER })
    .then((s) => {
      // Без пояса магазина слоты и «сегодня» не посчитать — как неудачная загрузка
      if (!s.shop_timezone) throw new Error('в настройках нет shop_timezone');
      cache = {
        timeSlots: Array.isArray(s.time_slots) ? s.time_slots : [],
        leadTimeMinutes: Number.isFinite(s.order_lead_time_minutes)
          ? s.order_lead_time_minutes : initial.leadTimeMinutes,
        shopTimezone: s.shop_timezone,
        loaded: true,
      };
      return cache;
    })
    .catch(() => initial);
}

const RETRY_MS = 5000;  // настройки не пришли (сеть) — повторяем, пока компонент жив

export function useDeliverySlots() {
  const [config, setConfig] = useState(cache || initial);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (config.loaded) return undefined;
    let alive = true;
    let timer = null;
    fetchDeliverySlots().then((c) => {
      if (!alive) return;
      if (c.loaded) setConfig(c);
      else timer = setTimeout(() => setAttempt((a) => a + 1), RETRY_MS);
    });
    return () => { alive = false; clearTimeout(timer); };
  }, [config.loaded, attempt]);
  return config;
}
